export var GieliCoordinates;
(function (GieliCoordinates) {
    function toCoords(comp) {
        const sextant = {
            offsetx: 2440,
            offsetz: 3161,
            minutespertile: 1.875
        };
        return {
            x: sextant.offsetx + Math.round((60 * comp.longitude.degrees + comp.longitude.minutes) * (comp.longitude.direction == "west" ? -1 : 1) / sextant.minutespertile),
            y: sextant.offsetz + Math.round((60 * comp.latitude.degrees + comp.latitude.minutes) * (comp.latitude.direction == "south" ? -1 : 1) / sextant.minutespertile),
            level: 0
        };
    }
    GieliCoordinates.toCoords = toCoords;
    function toString(c) {
        return `${c.latitude.degrees}°${c.latitude.minutes}' ${c.latitude.direction == "north" ? "N" : "S"}, ${c.longitude.degrees}°${c.longitude.minutes}' ${c.longitude.direction == "east" ? "E" : "W"}`;
    }
    GieliCoordinates.toString = toString;
})(GieliCoordinates || (GieliCoordinates = {}));
